import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as accountTypes from '@account/store/types'
import { mapActions, mapGetters } from 'vuex'
import menuHelper from '@appbase/util/menu-helper'
import modalHelper from '@appbase/util/modal-helper'
// components
import GnbItem from '@gnb/components/GlobalNavigationBarLeft/GnbItem.vue'
import GnbItemSub from '@gnb/components/GlobalNavigationBarLeft/GnbItemSub.vue'
import PreferenceModal from '@gnb/components/Preference/PreferenceModal.vue'

@Component({
  components: {
    GnbItem,
    GnbItemSub,
    PreferenceModal,
  },
  computed: {
    ...mapGetters({
      userCurrent: accountTypes.CURRENT,
    }),
  },
  methods: {
    ...mapActions({
      logout: accountTypes.LOGOUT,
    }),
  },
})
export default class GnbLeft extends Vue {
  userCurrent!: account.TCurrent
  menuItems: appbase.cache.TMenuItem[] = []
  subMenuItems: appbase.cache.TMenuItem[] = []
  menuPermission: account.TPermissionMenu[] = []
  isAdmin: boolean = false
  isDisplaySubMenu: boolean = false
  topMenuName: string = ''
  topMenuId: number = 0
  userLang: string = ''

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: A C T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  logout!: () => Promise<void>

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  // 메뉴 클릭 이벤트
  fnMenuClick(item: appbase.cache.TMenuItem) {
    if (item) {
      // Menu URL이 있는 경우 Menu 이동
      if (item.targetUrl) {
        this.fnCloseSubMenu()
        menuHelper.next(item)
      } else {
        // 1 Level 메뉴 중 URL이 없고 하위 메뉴가 존재할 경우 Sub Menu 표시
        if (item.parentMenuId == 0 && item.hasChildren && item.children.length > 0) {
          // Submenu가 표시중이며, 동일한 1 Level Menu를 클릭할 경우 Submenu를 닫아준다.
          if (this.isDisplaySubMenu && this.subMenuItems[0].parentMenuId == item.menuId){
            this.fnCloseSubMenu()
          }
          else{
            this.subMenuItems = item.children
            this.isDisplaySubMenu = true
            this.topMenuName = (this.userLang && this.userLang == 'ko-KR' ? item.menuName : item.menuNameEn)
          }
        } else {
          // URL 값은 없으나, 하위 메뉴의 첫 번째 Menu가 Target URL이 존재하는 경우 해당 URL로 이동
          if (item.hasChildren && item.children.length > 0 && item.children[0].targetUrl) {
            this.fnCloseSubMenu()
            menuHelper.next(item.children[0])
          }
        }
      }
    }
  }

  fnCloseSubMenu() {
    this.isDisplaySubMenu = false
    this.subMenuItems = []
  }

  // 환경설정
  fnSystemSetting() {
    modalHelper.show({ component: PreferenceModal, force: true, value: { aaa: 'aaa' } })
  }
  // 관리자 페이지
  fnAdminMenu() {
    // TODO : 관리자 페이지 Link 변경 필요
    document.location.href = 'http://175.106.97.142/admin'
  }

  // 메뉴 데이터 생성
  fnMakeMenuItem(
    childItems: appbase.cache.TMenuItem[],
    item: appbase.cache.TMenuItem,
    itemType: string
  ) {
    for (let i = 0; i < childItems.length; i++) {
      let isPermission =
        (itemType == 'S' ? true : childItems[i].isTopVisible) &&
        this.menuPermission.find((x) => x.id == childItems[i].menuId)
          ? true
          : false && childItems[i].callType == 'USER'

      if (isPermission && childItems[i].hasChildren) {
        this.fnMakeMenuItem(childItems[i].children, childItems[i], itemType)
      }

      if (i == 0) {
        item.children = []
        item.hasChildren = false
      }
      if (isPermission) {
        item.children.push(childItems[i])
      }
    }

    if (item.children.length > 0) {
      item.hasChildren = true
    }
  }

  // 메뉴 영역 밖에서 클릭 시 SubMenu 숨김 처리
  onClickEventCheck(e: Event) {
    let element = this.$el
    let eventTarget = e.target as HTMLElement
    if (element !== eventTarget && !element.contains(eventTarget) && this.isDisplaySubMenu) {
      this.fnCloseSubMenu()
    }
  }

  handleLogoff() {
    this.logout();
  }

  @Watch('$route.query')
  fnChangeUrl(){
    this.topMenuId = 0
    if (this.$route.query.MENUID){
      let paramMenuId = Number(this.$route.query.MENUID);
      let menuItem = menuHelper.getLeftMenuList(paramMenuId);
      if (menuItem){
        this.topMenuId = menuItem.menuId
      }
    }
  }

  created() {
    const excepts = ['MYPAGE']
    const { menu } = this.portalCache
    let mItems: appbase.cache.TMenuItem[] = menuHelper.setMenuParam(menu.items, this.userCurrent.user)
    this.menuPermission = this.userCurrent.permissions.menues
    this.isAdmin =
      this.userCurrent.permissions.isSuperAdmin || this.userCurrent.permissions.isCompanyManager
        ? true
        : false

    for (let i = 0; i < mItems.length; i++) {
      let mItem: appbase.cache.TMenuItem = mItems[i]
      if (
        mItem.isTopVisible == true &&
        !excepts.includes(mItem.callType) &&
        this.menuPermission.find((x) => x.id == mItem.menuId)
      ) {
        this.menuItems.push(mItem)
        if (mItem.hasChildren) {
          this.fnMakeMenuItem(mItem.children, mItem, 'M')
        }
      }
    }

    // 사용자 언어
    this.userLang = this.userCurrent.userConfig.language

    document.addEventListener('click', this.onClickEventCheck)
    // URL 변경 체크
    this.fnChangeUrl();
  }

  destroyed() {
    document.removeEventListener('click', this.onClickEventCheck)
  }
}
